exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-title-details[data-v-6173b017]{font-weight:700;width:200px;white-space:nowrap}", ""]);

// exports
